import { render, staticRenderFns } from "./ManagProfile.vue?vue&type=template&id=10c3c5c1&scoped=true&"
import script from "./ManagProfile.vue?vue&type=script&lang=js&"
export * from "./ManagProfile.vue?vue&type=script&lang=js&"
import style0 from "./ManagProfile.vue?vue&type=style&index=0&id=10c3c5c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3c5c1",
  null
  
)

export default component.exports